"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _require = require("docxtemplater"),
  _require$DocUtils = _require.DocUtils,
  traits = _require$DocUtils.traits,
  str2xml = _require$DocUtils.str2xml,
  xml2str = _require$DocUtils.xml2str,
  Errors = _require.Errors,
  XmlTemplater = _require.XmlTemplater;
var Pizzip = require("pizzip");
var _require2 = require("lodash"),
  get = _require2.get,
  forEach = _require2.forEach,
  clone = _require2.clone,
  values = _require2.values;
var _require3 = require("./attributes.js"),
  setSingleAttribute = _require3.setSingleAttribute,
  getSingleAttribute = _require3.getSingleAttribute;
var verifyApiVersion = require("./api-verify.js");
var normalizePath = require("./normalize-path.js");
var RelationsManager = require("./relationship-manager.js");
var _require4 = require("./tag.js"),
  isStartingTag = _require4.isStartingTag,
  isEndingTag = _require4.isEndingTag;
var uintarraytostring = require("docxtemplater/js/uintarray-to-string.js");
var updateTableRefTrait = require("./update-table-ref-trait.js");
var addChartTrait = require("./chart-manager.js");
var getAvailablePath = require("./get-available-path.js");
var pushArray = require("./push-array.js");
function insertAfter(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}
function shade(col, amt) {
  var num = parseInt(col, 16);
  var r = (num >> 16) + amt;
  if (r > 255) {
    r = 255;
  } else if (r < 0) {
    r = 0;
  }
  var b = (num >> 8 & 0x00ff) + amt;
  if (b > 255) {
    b = 255;
  } else if (b < 0) {
    b = 0;
  }
  var g = (num & 0x0000ff) + amt;
  if (g > 255) {
    g = 255;
  } else if (g < 0) {
    g = 0;
  }
  return (g | b << 8 | r << 16).toString(16);
}
var _require5 = require("./xl-utils.js"),
  letterToOrd = _require5.letterToOrd,
  getSquare = _require5.getSquare,
  getPosition = _require5.getPosition,
  parseRange = _require5.parseRange,
  parseSheetRange = _require5.parseSheetRange,
  stringifyRange = _require5.stringifyRange,
  stringifySheetRange = _require5.stringifySheetRange,
  offsetSquare = _require5.offsetSquare,
  getMaxTL = _require5.getMaxTL,
  getMaxBR = _require5.getMaxBR;
var moduleName = "open-xml-templating/docxtemplater-chart-module";
var moduleNameTitle = "open-xml-templating/docxtemplater-chart-title-module";
var NUMBER_OF_DAYS_BETWEEN_01_JAN_1900_AND_01_JAN_1970 = 25569;
var NUMBER_OF_DAYS_BETWEEN_01_JAN_1904_AND_01_JAN_1970 = 25569 - 365 * 4 - 2;
function getDir(x) {
  var parts = x.split("/");
  parts.pop();
  return parts.join("/");
}
function xmlize(zip) {
  return zip.file(/\.xml/).reduce(function (obj, f) {
    obj[f.name] = str2xml(f.asText());
    return obj;
  }, {});
}
function isXYDataSet(arr) {
  return arr.every(function (obj) {
    return obj === null || _typeof(obj) === "object" && "x" in obj && "y" in obj;
  });
}
function isXYSDataSet(arr) {
  return arr.every(function (obj) {
    return obj === null || _typeof(obj) === "object" && "x" in obj && "y" in obj && "size" in obj;
  });
}
function setText(xml, text) {
  if (xml.childNodes[0]) {
    xml.removeChild(xml.childNodes[0]);
  }
  xml.appendChild(xml.ownerDocument.createTextNode(text));
}
function getText(xml) {
  if (xml.childNodes.length === 0) {
    return "";
  }
  return xml.childNodes[0].nodeValue;
}
function addCellToRow(sheet, sharedStrings, row, square, data) {
  var cellTag = sheet.createElement("c");
  cellTag.setAttribute("r", square);
  var value = data;
  if (typeof data === "string") {
    cellTag.setAttribute("t", "s");
    var siTag = sharedStrings.createElement("si");
    siTag.appendChild(sheet.createElement("t"));
    sharedStrings.getElementsByTagName("sst")[0].appendChild(siTag);
    var length = sharedStrings.getElementsByTagName("si").length;
    value = length - 1;
  }
  var vTag = sheet.createElement("v");
  setText(vTag, value);
  cellTag.appendChild(vTag);
  row.appendChild(cellTag);
  var subcells = row.getElementsByTagName("c");
  var parsed = getPosition(square);
  var col = letterToOrd(parsed.col);
  var inserted = false;
  forEach(subcells, function (cell) {
    if (inserted) {
      return;
    }
    var cCol = letterToOrd(getPosition(cell.getAttribute("r")).col);
    if (cCol > col) {
      inserted = true;
      cell.parentNode.insertBefore(cellTag, cell);
    }
  });
  if (!inserted) {
    row.appendChild(cellTag);
  }
  return cellTag;
}
function findCell(sheet, position) {
  var rows = sheet.getElementsByTagName("row");
  for (var i = 0, len = rows.length; i < len; i++) {
    var row = rows[i];
    var cells = row.getElementsByTagName("c");
    for (var j = 0, _len = cells.length; j < _len; j++) {
      var cell = cells[j];
      var cellPos = getPosition(cell.getAttribute("r"));
      if (cellPos.col === position.col && cellPos.row === position.row) {
        return cell;
      }
    }
  }
  return null;
}
function createCell(sheet, sharedStrings, position, data) {
  var rows = sheet.getElementsByTagName("row");
  for (var i = 0, len = rows.length; i < len; i++) {
    var row = rows[i];
    var rowNum = +row.getAttribute("r");
    if (rowNum === position.row) {
      return addCellToRow(sheet, sharedStrings, row, getSquare(position), data);
    }
  }
}
function setCellValue(sheet, sharedStrings, cell, data) {
  var siTags = sharedStrings.getElementsByTagName("si");
  var cellType = cell.getAttribute("t");
  var vTag = cell.getElementsByTagName("v")[0];
  if (!vTag) {
    vTag = sheet.createElement("v");
    cell.appendChild(vTag);
  }

  // string type
  if (cellType === "s") {
    var iValue = vTag.childNodes[0].nodeValue;
    var siTag = siTags[+iValue];
    var textTags = siTag.getElementsByTagName("t");
    for (var i = 0, len = textTags.length; i < len; i++) {
      var textTag = textTags[i];
      siTag.removeChild(textTag);
    }
    var newTextTag = sharedStrings.createElement("t");
    newTextTag.setAttribute("xml:space", "preserve");
    var textNode = sharedStrings.createTextNode(data);
    newTextTag.appendChild(textNode);
    if (siTag.childNodes.length > 0) {
      siTag.insertBefore(newTextTag, siTag.childNodes[0]);
    } else {
      siTag.appendChild(newTextTag);
    }
    return;
  }
  // normal number
  if (data == null) {
    cell.removeChild(cell.getElementsByTagName("v")[0]);
  } else {
    setText(vTag, data);
  }
}
function calcDistance(p1, p2) {
  return Math.sqrt(Math.pow(p1.middlex - p2.middlex, 2) + Math.pow(p1.middley - p2.middley, 2));
}
function drop(xml) {
  xml.parentNode.removeChild(xml);
}
function dropAllChildren(xml) {
  while (xml.childNodes.length > 0) {
    xml.removeChild(xml.childNodes[0]);
  }
}
function computePositions(obj, p) {
  if (isStartingTag(p, "a:off")) {
    obj.x = parseInt(getSingleAttribute(p.value, "x"), 10);
    obj.y = parseInt(getSingleAttribute(p.value, "y"), 10);
  }
  if (isStartingTag(p, "a:ext")) {
    obj.cx = parseInt(getSingleAttribute(p.value, "cx"), 10);
    obj.cy = parseInt(getSingleAttribute(p.value, "cy"), 10);
  }
  if (obj.cx && obj.x) {
    obj.middlex = obj.cx / 2 + obj.x;
    obj.middley = obj.cy / 2 + obj.y;
    return true;
  }
}
function hasDuplicateFormula(formula, allFormulas) {
  var duplicate = null;
  allFormulas.forEach(function (_ref) {
    var otherFormula = _ref.formula,
      tag = _ref.tag;
    if (formula === otherFormula) {
      return;
    }
    if (otherFormula.start.col === formula.start.col && otherFormula.start.row === formula.start.row && tag.parentNode.parentNode.tagName !== "c:cat") {
      duplicate = true;
    }
  });
  return duplicate;
}

// eslint-disable-next-line complexity
function syncXlsxContent(sheet, parsed, data, sharedStrings) {
  var rows = sheet.getElementsByTagName("row");
  var maxYOffset = 0;
  for (var i = 0, len = rows.length; i < len; i++) {
    var row = rows[i];
    var rowNum = +row.getAttribute("r");
    var yOffset = rowNum - parsed.start.row;
    maxYOffset = yOffset;
  }
  if (maxYOffset < data.length) {
    var sheetData = sheet.getElementsByTagName("sheetData")[0];
    for (var _i = maxYOffset + 1, _len2 = data.length; _i < _len2; _i++) {
      var rowElement = sheet.createElement("row");
      var currentPos = {
        row: parsed.start.row + _i,
        col: parsed.start.col
      };
      rowElement.setAttribute("r", currentPos.row);
      sheetData.appendChild(rowElement);
    }
  }
  rows = sheet.getElementsByTagName("row");
  for (var _i2 = 0, _len3 = rows.length; _i2 < _len3; _i2++) {
    var _row = rows[_i2];
    var _rowNum = +_row.getAttribute("r");
    var _yOffset = _rowNum - parsed.start.row;
    var _currentPos = {
      row: parsed.start.row + _yOffset,
      col: parsed.start.col
    };
    var square = getSquare(_currentPos);
    var cells = _row.getElementsByTagName("c");
    var foundCell = null;
    for (var j = 0, _len4 = cells.length; j < _len4; j++) {
      var cell = cells[j];
      var cellPos = getPosition(cell.getAttribute("r"));
      if (cellPos.col === parsed.start.col && _yOffset >= 0) {
        foundCell = cell;
        break;
      }
    }
    if (_yOffset < 0 || _rowNum > parsed.end.row) {
      continue;
    }
    var dataItem = data[_yOffset];
    if (!foundCell) {
      foundCell = addCellToRow(sheet, sharedStrings, _row, square, dataItem);
    }
    setCellValue(sheet, sharedStrings, foundCell, dataItem);
  }
}
var ChartModule = /*#__PURE__*/function () {
  function ChartModule() {
    _classCallCheck(this, ChartModule);
    this.rms = {};
    this.requiredAPIVersion = "3.30.0";
    this.name = "ChartModule";
    this.supportedFileTypes = ["docx", "pptx", "xlsx"];
    this.ridFrames = {};
    this.prefix = "$";
    this.toSync = [];
    this.renderedRids = {};
  }
  _createClass(ChartModule, [{
    key: "clone",
    value: function clone() {
      return new ChartModule();
    }
  }, {
    key: "optionsTransformer",
    value: function optionsTransformer(options, docxtemplater) {
      var _this = this;
      this.docxtemplater = docxtemplater;
      verifyApiVersion(docxtemplater, this.requiredAPIVersion);
      this.fileTypeConfig = docxtemplater.fileTypeConfig;
      this.fileType = docxtemplater.fileType;
      this.zip = docxtemplater.zip;
      var relsFiles = this.zip.file(/\.xml\.rels/).concat(docxtemplater.zip.file(/\[Content_Types\].xml/)).concat(docxtemplater.zip.file(/(charts|drawings)\/.*.xml/)).concat(docxtemplater.zip.file(/ppt\/slides\/colors.*/)).map(function (file) {
        return file.name;
      });
      options.xmlFileNames = options.xmlFileNames.concat(relsFiles);
      this.fileTypeConfig.tagsXmlLexedArray.push("c:chart", "drawing", "p:graphicFrame", "a:off", "a:ext");
      this.fileTypeConfig.tagsXmlTextArray.push("a:t");
      docxtemplater.modules.forEach(function (module) {
        if (module.name === "XlsxModule") {
          _this.xlsxModule = module;
        }
      });
      return options;
    }
  }, {
    key: "set",
    value: function set(options) {
      if (options.xmlDocuments) {
        this.xmlDocuments = options.xmlDocuments;
      }
    }
  }, {
    key: "matchers",
    value: function matchers() {
      return [[this.prefix, moduleName]];
    }
  }, {
    key: "getRelationsManager",
    value: function getRelationsManager(filePath) {
      return getAvailablePath(addChartTrait(new RelationsManager(this, filePath)));
    }
  }, {
    key: "postparse",
    value: function postparse(parsed, options) {
      var _this2 = this;
      var parStart = [];
      var moduleParts = [];
      var graphicFrames = [];
      var filePath = options.filePath;
      var _traits$expandToOne = traits.expandToOne(parsed, {
          moduleName: moduleName,
          getInner: function getInner(_ref2) {
            var part = _ref2.part;
            return part;
          },
          expandTo: {
            docx: "w:p",
            pptx: "p:sp"
          }[this.fileType]
        }),
        postparsed = _traits$expandToOne.postparsed;
      var processChartTag = function processChartTag(obj, part, filePath) {
        var rId;
        if (typeof part === "string") {
          rId = part;
        } else {
          rId = getSingleAttribute(part.value, "r:id");
          obj.chartPart = part;
        }
        var chartManager = _this2.getRelationsManager(filePath);
        var _chartManager$getRela = chartManager.getRelationship(rId),
          target = _chartManager$getRela.target;
        var normalized = normalizePath(target, getDir(filePath)).substr(1);
        var subchartManager = _this2.getRelationsManager(normalized);
        var chartXml = _this2.xmlDocuments[normalized];
        var titleTag = chartXml.getElementsByTagName("c:title");
        if (titleTag[0]) {
          var paragraphTag = titleTag[0].getElementsByTagName("a:p");
          if (paragraphTag[0]) {
            var innerContent = "";
            for (var i = 0, len = paragraphTag[0].childNodes.length; i < len; i++) {
              var child = paragraphTag[0].childNodes[i];
              innerContent += xml2str(child);
            }
            var xmltemplater = new XmlTemplater(innerContent, _objectSpread({}, _this2.docxtemplater));
            xmltemplater.filePath = normalized;
            xmltemplater.contentType = _this2.docxtemplater.filesContentTypes[normalized];
            xmltemplater.preparse();
            xmltemplater.parse();
            var pp = xmltemplater.postparsed;
            pp.forEach(function (part) {
              if (part.module === moduleName) {
                part.frame = obj;
                part.insideChart = true;
                // This is in order to avoid having duplicate lIndex, see related test at #bug-lindex-chart
                part.lIndex = normalized + "-" + part.lIndex;
                moduleParts.push(part);
                pp.splice(pp.indexOf(part), 1);
              }
            });
            obj.titleTemplate = xmltemplater;
          }
        }
        obj.chartXml = chartXml;
        var extData = obj.chartXml.getElementsByTagName("c:externalData")[0];
        if (extData) {
          var _rId = extData.getAttribute("r:id");
          var relationship = subchartManager.getRelationship(_rId);
          if (relationship && relationship.target && relationship.targetMode !== "External" && !/\.xml$/.test(relationship.target)) {
            obj.subExcelPath = relationship.absoluteTarget;
            obj.subExcel = new Pizzip(_this2.zip.files[relationship.absoluteTarget].asBinary());
          }
        }
        obj.chartXmlPath = normalized;
        obj.rId = rId;
        obj.subchartManager = subchartManager;
        _this2.ridFrames[rId] = obj;
      };
      var self = this;
      function addChartPartRels(subchartManager, part) {
        var colorRel = subchartManager.findRelationship({
          Type: "http://schemas.microsoft.com/office/2011/relationships/chartColorStyle"
        });
        if (colorRel) {
          part.chart.color = colorRel.absoluteTarget;
          part.chart.colorVariations = [];
          part.chart.schemeClrs = [];
          var colorXml = self.xmlDocuments[part.chart.color];
          var variations = colorXml.getElementsByTagName("cs:variation");
          for (var i = 0, len = variations.length; i < len; i++) {
            var variation = variations[i];
            var lumMod = variation.getElementsByTagName("a:lumMod")[0];
            var lumOff = variation.getElementsByTagName("a:lumOff")[0];
            var colorVariation = {};
            if (lumMod) {
              colorVariation.lumMod = lumMod.getAttribute("val");
            }
            if (lumOff) {
              colorVariation.lumOff = lumOff.getAttribute("val");
            }
            part.chart.colorVariations.push(colorVariation);
          }
          var schemeColors = colorXml.getElementsByTagName("a:schemeClr");
          for (var _i3 = 0, _len5 = schemeColors.length; _i3 < _len5; _i3++) {
            var schemeColor = schemeColors[_i3];
            part.chart.schemeClrs.push(schemeColor.getAttribute("val"));
          }
        }
        var styleRel = subchartManager.findRelationship({
          Type: "http://schemas.microsoft.com/office/2011/relationships/chartStyle"
        });
        if (styleRel) {
          part.chart.style = styleRel.absoluteTarget;
        }
        var embeddingRel = subchartManager.findRelationship({
          Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/package"
        });
        if (embeddingRel) {
          part.chart.embedding = embeddingRel.absoluteTarget;
        }
      }
      if (this.fileType === "docx") {
        /* Transform this :
         * [
         *     ...,
         *     "<w:p>",
         *     "<c:chart>",
         *     ...,
         *     "</w:p>",
         *     { module: "open-xml-templating/docxtemplater-chart-module", value: "abc" },
         *     ...,
         * ]
         */

        postparsed.forEach(function (part) {
          if (part.type === "placeholder" && part.module === moduleName && part.expanded) {
            part.lastParagraph = parStart[parStart.length - 1];
            moduleParts.push(part);
          }
          if (isStartingTag(part, "w:p")) {
            parStart.push(part);
          }
          if (isStartingTag(part, "c:chart")) {
            graphicFrames.push({
              parts: [],
              lastParagraph: parStart[parStart.length - 1]
            });
            var lastFrame = graphicFrames[graphicFrames.length - 1];
            lastFrame.parts.push(part);
            processChartTag(lastFrame, part, options.filePath);
          }
        });
        moduleParts.forEach(function (modulePart) {
          graphicFrames.forEach(function (graphicFrame) {
            if (graphicFrame.lastParagraph === modulePart.lastParagraph) {
              modulePart.frame = graphicFrame;
            }
          });
        });
        moduleParts.forEach(function (modulePart) {
          var frame = modulePart.frame;
          var subchartManager = frame.subchartManager,
            rId = frame.rId;
          modulePart.chart = _objectSpread({}, frame);
          if (modulePart.chart.subExcel) {
            modulePart.chart.sheets = xmlize(modulePart.chart.subExcel);
          }
          delete _this2.ridFrames[rId];
          addChartPartRels(subchartManager, modulePart);
          if (modulePart.insideChart) {
            postparsed.splice(1, 0, modulePart);
          }
        });
      }
      if (this.fileType === "xlsx") {
        postparsed.forEach(function (part) {
          if (isStartingTag(part, "drawing")) {
            var rId = getSingleAttribute(part.value, "r:id");
            var chartManager = _this2.getRelationsManager(options.filePath);
            var _chartManager$getRela2 = chartManager.getRelationship(rId),
              target = _chartManager$getRela2.target;
            var normalized = normalizePath(target, getDir(options.filePath)).substr(1);
            var drawingXml = _this2.xmlDocuments[normalized];
            var charts = drawingXml.getElementsByTagName("c:chart");
            for (var i = 0, len = charts.length; i < len; i++) {
              var chart = charts[i];
              if (chart) {
                var xxx = {
                  drawingPath: normalized
                };
                var id = chart.getAttribute("r:id");
                processChartTag(xxx, id, normalized);
              }
            }
          }
        });
        moduleParts.forEach(function (modulePart) {
          var frame = modulePart.frame;
          var subchartManager = frame.subchartManager,
            rId = frame.rId;
          modulePart.chart = _objectSpread({}, frame);
          delete _this2.ridFrames[rId];
          addChartPartRels(subchartManager, modulePart);
          if (modulePart.insideChart) {
            postparsed.splice(1, 0, modulePart);
          }
        });
      }
      if (this.fileType === "pptx") {
        /* Transform this :
         * [
         *     ...,
         *     "<p:graphicFrame>",
         *     "<c:chart>",
         *     ...,
         *     "</p:graphicFrame>",
         *     { module: "open-xml-templating/docxtemplater-chart-module", value: "chart" },
         *     ...,
         * ]
         *
         * into this :
         *
         * [
         *   ...,
         *   {
         *     module: "open-xml-templating/docxtemplater-chart-module",
         *     value: "chart"
         *     chart : {
         *        chartXml,
         *        chartXmlPath,
         *        rId,
         *        subExcel,
         *        subExcelPath,
         *        titleTemplate,
         *     },
         *   },
         *   ...,
         * ]
         * chartXml,
         * chartXmlPath,
         * rId,
         * cel: frame.subExcel,
         * subExcelPath: frame.subExcelPath,
         * titleTemplate: frame.titleTemplate,
         *
         * Using a minimal distance algorithm : match the closest {$chart} elements with the graphicFrame
         */
        var inGraphicFrame = false;
        postparsed.forEach(function (part) {
          if (part.type === "placeholder" && part.module === moduleName && part.expanded) {
            part.expanded[0].some(function (p) {
              return computePositions(part, p);
            });
            moduleParts.push(part);
          }
          if (isStartingTag(part, "p:graphicFrame")) {
            inGraphicFrame = true;
            graphicFrames.push({
              parts: []
            });
          }
          var lastFrame = graphicFrames[graphicFrames.length - 1];
          if (inGraphicFrame) {
            lastFrame.parts.push(part);
            computePositions(lastFrame, part);
          }
          if (isEndingTag(part, "p:graphicFrame")) {
            inGraphicFrame = false;
          }
          if (isStartingTag(part, "c:chart")) {
            processChartTag(lastFrame, part, options.filePath);
          }
        });
        var nearestFrames = [];
        moduleParts.forEach(function (modulePart) {
          if (modulePart.insideChart) {
            return;
          }
          var minDistance = null;
          var nearestFrame = null;
          graphicFrames.forEach(function (graphicFrame) {
            var distance = calcDistance(modulePart, graphicFrame);
            if (minDistance == null || distance < minDistance) {
              minDistance = distance;
              nearestFrame = graphicFrame;
            }
          });
          if (nearestFrames.indexOf(nearestFrame) !== -1) {
            throw new Error("Duplicate chart tags, please replace your chart tags");
          }
          modulePart.frame = nearestFrame;
          nearestFrames.push(nearestFrame);
        });
        moduleParts.forEach(function (modulePart) {
          var frame = modulePart.frame;
          var subchartManager = frame.subchartManager,
            rId = frame.rId;
          modulePart.chart = _objectSpread({}, frame);
          if (modulePart.chart.subExcel) {
            modulePart.chart.sheets = xmlize(modulePart.chart.subExcel);
          }
          delete _this2.ridFrames[rId];
          addChartPartRels(subchartManager, modulePart);
          if (modulePart.insideChart) {
            postparsed.splice(1, 0, modulePart);
          }
        });
      }
      postparsed = postparsed.map(function (part) {
        if (part.tag === "c:chart") {
          var rId = getSingleAttribute(part.value, "r:id");
          var frame = _this2.ridFrames[rId];
          if (!frame || !frame.titleTemplate) {
            return part;
          }
          var chartXml = frame.chartXml;
          return {
            type: "placeholder",
            module: moduleNameTitle,
            rId: rId,
            chartXml: _this2.getUpdatedChartXml(filePath, rId, chartXml),
            value: "",
            frame: frame,
            expanded: [part]
          };
        }
        return part;
      });
      return postparsed;
    }
  }, {
    key: "templateChartTitle",
    value: function templateChartTitle(part, options) {
      var scopeManager = options.scopeManager,
        filePath = options.filePath;
      var content;
      var titleTemplate = part.frame.titleTemplate;
      var chartXml = part.chartXml;
      if (titleTemplate.rendered) {
        content = titleTemplate.content;
      } else {
        titleTemplate.filePath = filePath;
        titleTemplate.scopeManager = scopeManager;
        titleTemplate.postparsed.forEach(function (p) {
          p.lIndex = filePath + "-" + p.lIndex;
        });
        titleTemplate.render(titleTemplate.filePath);
        if (titleTemplate.allErrors.length > 0) {
          return {
            errors: titleTemplate.allErrors
          };
        }
        content = titleTemplate.content;
      }
      var titleTag = chartXml.getElementsByTagName("c:title");
      var hasTitle = content.indexOf("{title}");
      if (hasTitle !== -1) {
        throw new Error("hasTitle at pos ".concat(hasTitle));
      }
      var paragraphTag = titleTag[0].getElementsByTagName("a:p");
      if (typeof content !== "string") {
        content = uintarraytostring(content);
      }
      if (paragraphTag[0]) {
        dropAllChildren(paragraphTag[0]);
        var newChild = str2xml("<x>".concat(content, "</x>")).childNodes[0];
        var childs = [];
        for (var i = 0, len = newChild.childNodes.length; i < len; i++) {
          childs.push(newChild.childNodes[i]);
        }
        childs.forEach(function (child) {
          paragraphTag[0].appendChild(child);
        });
      }
      if (part.module === moduleName) {
        return {
          value: ""
        };
      }
      return {
        value: part.expanded[0].value
      };
    }
  }, {
    key: "getUpdatedChartXml",
    value: function getUpdatedChartXml(filePath, rId, chartXml) {
      var relManager = new RelationsManager(this, filePath);
      var rel = relManager.findRelationship({
        Id: rId
      });
      return this.xmlDocuments[rel.absoluteTarget] = str2xml(xml2str(chartXml));
    }
  }, {
    key: "resolve",
    value: function resolve(part, options) {
      if (!part.type === "placeholder" || [moduleName, moduleNameTitle].indexOf(part.module) === -1) {
        return null;
      }
      var scopeManager = options.scopeManager,
        filePath = options.filePath;
      var promisedValue = scopeManager.getValueAsync(part.value, {
        part: part
      });
      if (!part.frame.titleTemplate) {
        return promisedValue;
      }
      return promisedValue.then(function (value) {
        var titleTemplate = part.frame.titleTemplate;
        titleTemplate.filePath = filePath;
        titleTemplate.postparsed.forEach(function (p) {
          p.lIndex = filePath + "-" + p.lIndex;
        });
        function renderFinal() {
          titleTemplate.render(filePath);
          if (titleTemplate.allErrors.length > 0) {
            throw new Error("Error rendering titleTemplate");
          }
          titleTemplate.rendered = true;
          return value;
        }
        if (part.module === moduleName) {
          var sm = scopeManager.createSubScopeManager(value, part.value, 0, part, 1);
          titleTemplate.scopeManager = sm;
          return renderFinal();
        }
        titleTemplate.scopeManager = scopeManager;
        return titleTemplate.resolveTags(value).then(renderFinal);
      });
    }
    // eslint-disable-next-line complexity
  }, {
    key: "render",
    value: function render(part, options) {
      var _this$renderedRids;
      var filePath = options.filePath,
        scopeManager = options.scopeManager;
      if (!part.type === "placeholder" || [moduleName, moduleNameTitle].indexOf(part.module) === -1) {
        return null;
      }
      if (part.module === moduleNameTitle) {
        return this.templateChartTitle(part, options);
      }
      var errors = [];
      var self = this;
      var _part$chart = part.chart,
        chartXml = _part$chart.chartXml,
        drawingPath = _part$chart.drawingPath,
        subExcel = _part$chart.subExcel,
        subExcelPath = _part$chart.subExcelPath;
      var rId = part.chart.rId;
      var chartManager = this.getRelationsManager(options.filePath);
      if (this.fileType !== "xlsx") {
        var _chartManager$getRela3 = chartManager.getRelationship(rId),
          target = _chartManager$getRela3.target;
        var normalized = normalizePath(target, getDir(filePath)).substr(1);
        var subchartManager = this.getRelationsManager(normalized);
        var extData = chartXml.getElementsByTagName("c:externalData")[0];
        if (extData) {
          var _rId2 = extData.getAttribute("r:id");
          var relationship = subchartManager.getRelationship(_rId2);
          if (relationship && relationship.target && relationship.targetMode !== "External" && !/\.xml$/.test(relationship.target)) {
            subExcelPath = relationship.absoluteTarget;
            subExcel = new Pizzip(this.zip.files[relationship.absoluteTarget].asBinary());
          }
        }
      }
      var _part$chart2 = part.chart,
        titleTemplate = _part$chart2.titleTemplate,
        sheets = _part$chart2.sheets;
      (_this$renderedRids = this.renderedRids)[filePath] || (_this$renderedRids[filePath] = {});
      if (this.renderedRids[filePath][rId]) {
        var _result = chartManager.addChart(part.frame.chartXmlPath, this.zip.files);
        rId = _result.rId;
        var pathMap = _result.pathMap;
        subExcelPath = pathMap[subExcelPath];
        subExcel = new Pizzip(this.zip.files[subExcelPath].asBinary());
        chartXml = str2xml(this.zip.files[pathMap[part.frame.chartXmlPath]].asText());
        drawingPath = pathMap[drawingPath];
        part.frame.chartPart.value = setSingleAttribute(part.frame.chartPart.value, "r:id", rId);
      }
      this.renderedRids[filePath][rId] = true;
      var myChartXml = this.getUpdatedChartXml(this.fileType === "xlsx" ? drawingPath : filePath, rId, chartXml);
      var tagValue = scopeManager.getValue(part.value, {
        part: part
      });
      var result = {
        value: ""
      };
      if (titleTemplate) {
        var titleResult = this.templateChartTitle({
          module: part.module,
          frame: part.chart,
          chartXml: myChartXml
        }, _objectSpread(_objectSpread({}, options), {}, {
          scopeManager: tagValue ? scopeManager.createSubScopeManager(tagValue, part.value, 0, part, 1) : scopeManager
        }));
        if (titleResult.errors) {
          pushArray(errors, titleResult.errors);
        }
      }
      if (!tagValue) {
        return result;
      }
      function replaceTagName(xml, name1, name2) {
        var start = xml.getElementsByTagName(name1)[0];
        var replaced = myChartXml.createElement(name2);
        var index;

        // Copy the children
        while (start.firstChild) {
          replaced.appendChild(start.firstChild); // *Moves* the child
        }

        // Copy the attributes
        for (index = start.attributes.length - 1; index >= 0; --index) {
          replaced.attributes.setNamedItem(start.attributes[index].cloneNode());
        }

        // Replace it
        start.parentNode.replaceChild(replaced, start);
      }
      function ensureDirectChild(xml, childName) {
        for (var i = 0, len = xml.childNodes.length; i < len; i++) {
          var _child = xml.childNodes[i];
          if (_child.tagName === childName) {
            return _child;
          }
        }
        var child = myChartXml.createElement(childName);
        xml.insertBefore(child, xml.childNodes[0]);
        return child;
      }
      var sheetPath = "xl/worksheets/sheet1.xml";
      var firstSheet;
      var sharedStrings;
      var tableParts;
      var topLeft = {};
      var bottomRight = {};
      var myTables = [];
      var maxLength = 0;
      if (sheets) {
        firstSheet = sheets[sheetPath];
        sharedStrings = sheets["xl/sharedStrings.xml"];
        if (firstSheet) {
          tableParts = firstSheet.getElementsByTagName("tablePart");
          var relationsManager = updateTableRefTrait(new RelationsManager({
            zip: subExcel,
            xmlDocuments: sheets,
            fileType: "xlsx"
          }, sheetPath));
          if (tableParts.length) {
            for (var i = 0, len = tableParts.length; i < len; i++) {
              var tablePart = tableParts[i];
              var _rId3 = tablePart.getAttribute("r:id");
              relationsManager.addTablePart(_rId3);
            }
          }
          myTables = relationsManager.myTables || [];
          myTables.forEach(function (myTable) {
            var startRef = myTable.xml.getAttribute("ref");
            var range = parseRange(startRef);
            topLeft = range[0];
            bottomRight = range[1];
          });
        }
      }
      var cellVals = {};

      // eslint-disable-next-line complexity
      function syncXml(xml, data) {
        var formulaTag = xml.getElementsByTagName("c:f")[0];
        if (!formulaTag) {
          return;
        }
        var formula = formulaTag.childNodes[0].nodeValue;
        var fullText = formulaTag.childNodes[0].nodeValue;
        if (fullText.indexOf("!") !== -1) {
          var parsed = parseSheetRange(fullText);
          var startPos = parsed.start;
          parsed.end = {
            row: startPos.row + data.length - 1,
            col: startPos.col
          };
          setText(formulaTag, stringifySheetRange(parsed));
          for (var _i4 = parsed.start.row; _i4 <= parsed.end.row; _i4++) {
            var currentPos = {
              row: _i4,
              col: startPos.col
            };
            var square = getSquare(currentPos);
            topLeft = getMaxTL(topLeft, currentPos);
            bottomRight = getMaxBR(bottomRight, currentPos);
            var dataItem = data[_i4 - parsed.start.row];
            cellVals[square] = dataItem;
          }
          if (self.fileType === "xlsx") {
            var _sheets = self.xlsxModule.sheets;
            self.namesToSheet = Object.keys(_sheets).reduce(function (namesToSheet, filePath) {
              namesToSheet[_sheets[filePath].name] = filePath;
              return namesToSheet;
            }, {});
            var sheetName = parsed.sheet;
            self.toSync.push({
              path: self.namesToSheet[sheetName].substr(1),
              parsed: parsed,
              data: data,
              filePath: filePath
            });
          } else if (firstSheet) {
            syncXlsxContent(firstSheet, parsed, data, sharedStrings);
          }
        }
        var ptCount = xml.getElementsByTagName("c:ptCount")[0];
        ptCount.setAttribute("val", data.length);
        var xmlValues = xml.getElementsByTagName("c:v");
        var maxIdx = 0;
        var idxToNode = {};
        for (var j = 0, len2 = xmlValues.length; j < len2; j++) {
          var node = xmlValues[j];
          var idx = parseInt(node.parentNode.getAttribute("idx"), 10);
          idxToNode[idx] = node;
          if (idx > maxIdx) {
            maxIdx = idx;
          }
        }
        if (formula[0] === "{") {
          setText(formulaTag, "{".concat(data.join(","), "}"));
        }
        for (var _i5 = 0, _len6 = Math.max(data.length, maxIdx + 1); _i5 < _len6; _i5++) {
          var _node = idxToNode[_i5];
          if (data[_i5] == null) {
            if (_node) {
              drop(_node.parentNode);
            }
            continue;
          }
          if (!_node) {
            // <c:numCache> || <c:strCache>
            // <c:pt idx="0">
            // <c:v>1st Qtr</c:v>
            // </c:pt>
            // </c:numCache> || </c:strCache>
            var ptTag = myChartXml.createElement("c:pt");
            ptTag.setAttribute("idx", _i5);
            var cvTag = myChartXml.createElement("c:v");
            _node = cvTag;
            ptTag.appendChild(cvTag);
            ptCount.parentNode.appendChild(ptTag);
          }
          setText(_node, data[_i5]);
        }
      }
      function getError() {
        var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var err = new Errors.RenderingError("Invalid input ".concat(extra ? "(".concat(extra, ") ") : "", "for chart data '").concat(part.value, "'"));
        err.properties = {
          explanation: "Chart data is invalid for '".concat(part.value, "'"),
          id: "chart_data_invalid",
          xtag: part.value
        };
        return err;
      }
      if (tagValue.data) {
        tagValue.series = [{
          data: tagValue.data
        }];
        delete tagValue.data;
      }
      if (tagValue.series) {
        tagValue.series.forEach(function (_ref3) {
          var data = _ref3.data;
          maxLength = Math.max(maxLength, data.length);
        });
      }
      if (tagValue.categories && tagValue.series) {
        if (!(tagValue.categories instanceof Array) || !(tagValue.series instanceof Array)) {
          return {
            errors: [getError()]
          };
        }
        var error = null;
        tagValue.series.forEach(function (serie) {
          if (!(serie.data instanceof Array)) {
            error = getError();
          }
          if (serie.data.length !== tagValue.categories.length) {
            error = getError("incoherent length");
          }
          serie.data.forEach(function (data) {
            if (data != null && typeof data !== "number") {
              if (_typeof(data) === "object" && typeof data.x === "number") {
                return;
              }
              error = getError("invalid data type : " + _typeof(data));
            }
          });
        });
        if (error) {
          return {
            errors: [error]
          };
        }
      }
      var dateEls = myChartXml.getElementsByTagName("c:date1904");
      var start1904 = dateEls.length > 0 && dateEls[0].getAttribute("val") === "true";
      if (tagValue.categories) {
        var xmlSeries = myChartXml.getElementsByTagName("c:ser");
        for (var _i6 = 0, _len7 = xmlSeries.length; _i6 < _len7; _i6++) {
          var serie = xmlSeries[_i6];
          var categories = serie.getElementsByTagName("c:cat");
          if (categories.length === 0) {
            var cat = ensureDirectChild(serie, "c:cat");
            var strRef = ensureDirectChild(cat, "c:strRef");
            var strCache = ensureDirectChild(strRef, "c:strCache");
            var formula = ensureDirectChild(strRef, "c:f");
            formula.appendChild(serie.ownerDocument.createTextNode("{}"));
            var ptCount = ensureDirectChild(strCache, "c:ptCount");
            ptCount.setAttribute("val", "0");
          }
        }
        var cats = myChartXml.getElementsByTagName("c:cat");
        if (tagValue.categories[0] instanceof Date) {
          for (var _i7 = 0, _len8 = cats.length; _i7 < _len8; _i7++) {
            var ref = cats[_i7].getElementsByTagName("c:strRef");
            if (ref.length > 0) {
              replaceTagName(cats[_i7], "c:strRef", "c:numRef");
              replaceTagName(cats[_i7], "c:strCache", "c:numCache");
              var format = ensureDirectChild(cats[_i7].getElementsByTagName("c:numCache")[0], "c:formatCode");
              setText(format, "mm/dd/yyyy");
            }
            syncXml(cats[_i7], tagValue.categories.map(function (date) {
              return Math.floor(+date / 3600 / 24 / 1000) + (start1904 ? NUMBER_OF_DAYS_BETWEEN_01_JAN_1904_AND_01_JAN_1970 : NUMBER_OF_DAYS_BETWEEN_01_JAN_1900_AND_01_JAN_1970);
            }), "categories");
          }
        } else {
          for (var _i8 = 0, _len9 = cats.length; _i8 < _len9; _i8++) {
            syncXml(cats[_i8], tagValue.categories, "categories");
          }
        }
      }
      if (tagValue.series) {
        var totalLength = 0;
        for (var _i9 = 0, _len10 = tagValue.series.length; _i9 < _len10; _i9++) {
          var data = tagValue.series[_i9].data;
          if (isXYDataSet(data)) {
            totalLength += data.length;
          }
        }
        var currentLength = 0;
        for (var _i10 = 0, _len11 = tagValue.series.length; _i10 < _len11; _i10++) {
          var _data = tagValue.series[_i10].data;
          if (isXYDataSet(_data)) {
            for (var j = 0, len2 = currentLength; j < len2; j++) {
              _data.unshift(null);
            }
            currentLength += tagValue.series[_i10].data.length;
            for (var _j = 0, _len12 = totalLength - tagValue.series[_i10].data.length; _j < _len12; _j++) {
              _data.push(null);
            }
          }
        }
        var allFormulas = [];
        var _xmlSeries = myChartXml.getElementsByTagName("c:ser");
        for (var _i11 = 0, _len13 = _xmlSeries.length; _i11 < _len13; _i11++) {
          var _serie = _xmlSeries[_i11];
          var formulas = _serie.getElementsByTagName("c:f");
          for (var _j2 = 0, _len14 = formulas.length; _j2 < _len14; _j2++) {
            var formulaTag = formulas[_j2];
            var _formula = formulaTag.childNodes[0].nodeValue;
            if (_formula[0] === "{" || _formula[0] === '"' || _formula.indexOf("!") === -1) {
              continue;
            }
            var parsed = parseSheetRange(_formula);
            allFormulas.push({
              formula: parsed,
              tag: formulaTag
            });
          }
          var dPts = _serie.getElementsByTagName("c:dPt");
          var dPtsLength = dPts.length;
          var defaultColor = void 0;
          if (!part.chart.colorVariations) {
            var spPr = _serie.getElementsByTagName("c:spPr")[0];
            if (spPr) {
              var fill = spPr.getElementsByTagName("a:solidFill")[0];
              if (fill) {
                var srgbClr = fill.getElementsByTagName("a:srgbClr")[0];
                if (srgbClr) {
                  defaultColor = srgbClr.getAttribute("val");
                }
              }
            }
            if (dPtsLength > 0) {
              var lastDpt = dPts[dPts.length - 1];
              for (var _i12 = dPtsLength; _i12 < maxLength; _i12++) {
                var _j3 = _i12 % dPtsLength;
                var divisionRest = (_i12 - _j3) / dPtsLength;
                var currentDpt = dPts[_j3];
                var _clone = str2xml(xml2str(currentDpt)).childNodes[0];
                var idx = _clone.getElementsByTagName("c:idx")[0];
                idx.setAttribute("val", _i12);
                var _spPr = _clone.getElementsByTagName("c:spPr")[0];
                if (!_spPr) {
                  _spPr = ensureDirectChild(_clone, "c:spPr");
                }
                var _fill = _spPr.getElementsByTagName("a:solidFill")[0];
                if (!_fill) {
                  _fill = ensureDirectChild(_spPr, "a:solidFill");
                }
                var _srgbClr = ensureDirectChild(_fill, "a:srgbClr");
                var color = _srgbClr.getAttribute("val") || defaultColor;
                var shadedColor = shade(color, 30 * divisionRest);
                _srgbClr.setAttribute("val", shadedColor);
                insertAfter(_clone, lastDpt);
                lastDpt = _clone;
              }
            }
          }
        }
        if (firstSheet) {
          var rows = firstSheet.getElementsByTagName("row");
          for (var _i13 = 0, _len15 = rows.length; _i13 < _len15; _i13++) {
            var row = rows[_i13];
            var cells = row.getElementsByTagName("c");
            for (var _j4 = 0, _len16 = cells.length; _j4 < _len16; _j4++) {
              var cell = cells[_j4];
              var cellSquare = cell.getAttribute("r");
              var t = cell.getAttribute("t");
              if (t === "s") {
                var vTag = cell.getElementsByTagName("v")[0];
                var siNum = +getText(vTag);
                var tTag = sharedStrings.getElementsByTagName("si")[siNum].getElementsByTagName("t")[0];
                var text = getText(tTag);
                cellVals[cellSquare] = text;
                if (text === "") {
                  tTag.removeAttribute("xml:space");
                }
              }
            }
          }
          allFormulas.forEach(function (x) {
            var baseFormula = clone(x.formula.start);
            while (hasDuplicateFormula(x.formula, allFormulas)) {
              x.formula.start = offsetSquare(x.formula.start, {
                col: 1,
                row: 0
              });
              x.formula.end = offsetSquare(x.formula.end, {
                col: 1,
                row: 0
              });
              if (!hasDuplicateFormula(x.formula, allFormulas)) {
                var startSquare = getSquare(_objectSpread(_objectSpread({}, baseFormula), {}, {
                  row: 1
                }));
                var endSquare = getSquare(_objectSpread(_objectSpread({}, x.formula.start), {}, {
                  row: 1
                }));
                var baseTitle = cellVals[startSquare];
                var _titles = values(cellVals);
                var num = 1;
                var newTitle = baseTitle;
                if (newTitle === " ") {
                  newTitle = "Column";
                }
                while (_titles.indexOf(newTitle) !== -1) {
                  num++;
                  newTitle = baseTitle.replace(/\d+$/g, "") + num;
                }
                cellVals[endSquare] = newTitle;
                var _cell = findCell(firstSheet, getPosition(endSquare));
                if (!_cell) {
                  _cell = createCell(firstSheet, sharedStrings, _objectSpread(_objectSpread({}, x.formula.start), {}, {
                    row: 1
                  }), newTitle);
                }
                setCellValue(firstSheet, sharedStrings, _cell, newTitle);
                setText(x.tag, stringifySheetRange(x.formula));
              }
            }
          });
        }
        var initialSeriesLength = _xmlSeries.length;
        if (_xmlSeries.length < tagValue.series.length) {
          var lastSerie = _xmlSeries[_xmlSeries.length - 1];
          for (var _i14 = 0, _len17 = tagValue.series.length - _xmlSeries.length; _i14 < _len17; _i14++) {
            var duplicate = str2xml(xml2str(lastSerie)).childNodes[0];
            ensureDirectChild(duplicate, "c:idx").setAttribute("val", _xmlSeries.length);
            ensureDirectChild(duplicate, "c:order").setAttribute("val", _xmlSeries.length);
            var _formulas = duplicate.getElementsByTagName("c:f");
            for (var _j5 = 0, _len18 = _formulas.length; _j5 < _len18; _j5++) {
              var _formulaTag = _formulas[_j5];
              var _formula2 = _formulaTag.childNodes[0].nodeValue;
              if (_formula2[0] === "{" || _formula2[0] === '"') {
                continue;
              }
              var _parsed = parseSheetRange(_formula2);
              _parsed.start = offsetSquare(_parsed.start, {
                col: _i14 + 1,
                row: 0
              });
              if (_parsed.end) {
                _parsed.end = offsetSquare(_parsed.end, {
                  col: _i14 + 1,
                  row: 0
                });
              }
              var newFormula = stringifySheetRange(_parsed);
              setText(_formulaTag, newFormula);
            }
            var _fill2 = duplicate.getElementsByTagName("a:solidFill");
            if (_fill2.length === 1) {
              var clrElement = _fill2[0].getElementsByTagName("a:schemeClr")[0];
              if (clrElement) {
                var val = clrElement.getAttribute("val");
                if (val.indexOf("accent") === 0) {
                  var schemeCount = part.chart.schemeClrs.length;
                  var cvCount = part.chart.colorVariations.length;
                  var index = initialSeriesLength + _i14;
                  var newAccent = part.chart.schemeClrs[index % schemeCount];
                  var newVariation = part.chart.colorVariations[Math.floor(index / schemeCount) % cvCount];
                  clrElement.setAttribute("val", newAccent);
                  if (newVariation.lumMod) {
                    ensureDirectChild(clrElement, "a:lumMod").setAttribute("val", newVariation.lumMod);
                  }
                  if (newVariation.lumOff) {
                    ensureDirectChild(clrElement, "a:lumOff").setAttribute("val", newVariation.lumOff);
                  }
                }
              }
            }
            lastSerie.parentNode.appendChild(duplicate);
          }
        }
        _xmlSeries = myChartXml.getElementsByTagName("c:ser");
        var titles = [];
        var newTitles = [],
          toDrop = [];
        for (var _i15 = 0, _len19 = _xmlSeries.length; _i15 < _len19; _i15++) {
          var xmlSerie = _xmlSeries[_i15];
          var findTitleAlternative = true;
          var baseTitle = "";
          var newTitle = void 0;
          var txElement = xmlSerie.getElementsByTagName("c:tx")[0];
          if (tagValue.series.length <= _i15) {
            toDrop.push(xmlSerie);
            continue;
          }
          if (txElement) {
            if (tagValue.series[_i15].title == null) {
              if (_i15 < initialSeriesLength - 1) {
                findTitleAlternative = false;
                var cV = txElement.getElementsByTagName("c:v")[0];
                if (cV) {
                  baseTitle = cV.textContent;
                }
              } else {
                var _cV = txElement.getElementsByTagName("c:v")[0];
                if (_cV) {
                  baseTitle = _cV.textContent;
                }
              }
            } else {
              baseTitle = tagValue.series[_i15].title;
            }
          }
          newTitle = baseTitle;
          if (findTitleAlternative) {
            newTitle = baseTitle;
            if (newTitle === " ") {
              newTitle = "Column";
            }
            var num = 1;
            while (titles.indexOf(newTitle) !== -1) {
              num++;
              newTitle = baseTitle.replace(/\d+$/g, "") + num;
            }
          }
          titles.push(newTitle);
          if (txElement) {
            syncXml(txElement, [titles[_i15]], "title");
          }
          var normalVal = xmlSerie.getElementsByTagName("c:val")[0];
          var xVal = xmlSerie.getElementsByTagName("c:xVal")[0];
          var yVal = xmlSerie.getElementsByTagName("c:yVal")[0];
          if (typeof tagValue.series[0].data[0] === "number") {
            if (!normalVal) {
              var err = new Errors.RenderingError("Cannot use data source with numbers only for scatterplot graph, please use data in the form of [{x: 33, y: 22}, ...]");
              err.properties = {
                xtag: part.value,
                explanation: "Cannot use data source with numbers only for scatterplot graph",
                id: "invalid_data_source_numbers_scatterplot"
              };
              errors.push(err);
            } else {
              syncXml(normalVal, tagValue.series[_i15].data, "data");
            }
          } else if (isXYDataSet(tagValue.series[0].data)) {
            var xVals = tagValue.series[_i15].data.map(function (val) {
              return val === null || val === void 0 ? void 0 : val.x;
            });
            var yVals = tagValue.series[_i15].data.map(function (val) {
              return val === null || val === void 0 ? void 0 : val.y;
            });
            var xMax = Math.max.apply(Math, _toConsumableArray(xVals));
            var yMax = Math.max.apply(Math, _toConsumableArray(yVals));
            var xMin = Math.min.apply(Math, _toConsumableArray(xVals));
            var yMin = Math.min.apply(Math, _toConsumableArray(yVals));
            var axes = myChartXml.getElementsByTagName("c:valAx");
            for (var _i16 = 0, _len20 = axes.length; _i16 < _len20; _i16++) {
              var axis = axes[_i16];
              var axPosition = axis.getElementsByTagName("c:axPos")[0].getAttribute("val");

              // l => left
              // t => top
              // b => bottom
              // r => right
              var axisName = {
                l: "y",
                r: "y",
                t: "x",
                b: "x"
              }[axPosition];
              if (axisName) {
                var _scalingTag$getElemen, _scalingTag$getElemen2;
                var scalingTag = axis.getElementsByTagName("c:scaling")[0];
                scalingTag === null || scalingTag === void 0 ? void 0 : (_scalingTag$getElemen = scalingTag.getElementsByTagName("c:max")[0]) === null || _scalingTag$getElemen === void 0 ? void 0 : _scalingTag$getElemen.setAttribute("val", axisName === "x" ? xMax : yMax);
                scalingTag === null || scalingTag === void 0 ? void 0 : (_scalingTag$getElemen2 = scalingTag.getElementsByTagName("c:min")[0]) === null || _scalingTag$getElemen2 === void 0 ? void 0 : _scalingTag$getElemen2.setAttribute("val", axisName === "x" ? xMin : yMin);
              }
            }
            syncXml(xVal, xVals, "data");
            syncXml(yVal, yVals, "data");
            var bubbleSize = xmlSerie.getElementsByTagName("c:bubbleSize")[0];
            if (bubbleSize && !isXYSDataSet(tagValue.series[_i15].data)) {
              var _err = new Errors.RenderingError("Cannot use data source without sizes on scatterplot with sizes");
              _err.properties = {
                xtag: part.value,
                explanation: "Cannot use data source without sizes on scatterplot with sizes",
                id: "scatterplot_without_size_on_scatterplot_with_size"
              };
              errors.push(_err);
            }
            if (!bubbleSize && isXYSDataSet(tagValue.series[_i15].data)) {
              var _err2 = new Errors.RenderingError("Cannot use data source with sizes on scatterplot without sizes");
              _err2.properties = {
                xtag: part.value,
                explanation: "Cannot use data source with sizes on scatterplot without sizes",
                id: "scatterplot_size_on_scatterplot_without_size"
              };
              errors.push(_err2);
            }
            if (bubbleSize) {
              syncXml(bubbleSize, tagValue.series[_i15].data.map(function (val) {
                return val === null || val === void 0 ? void 0 : val.size;
              }), "data");
            }
          }
        }
        toDrop.forEach(drop);
        Object.keys(cellVals).forEach(function (key) {
          var position = getPosition(key);
          if (position.row === 1) {
            var value = cellVals[key];
            newTitles.push(value);
          }
        });
        titles = newTitles;
        var columnsToDrop = [];
        if (titles.length > 0) {
          myTables.forEach(function (myTable) {
            var tcParent = myTable.xml.getElementsByTagName("tableColumns")[0];
            tcParent.setAttribute("count", titles.length);
            var columns = myTable.xml.getElementsByTagName("tableColumn");
            var lastId = -1;
            var lastDxfId = -1;
            for (var _i17 = 0, _len21 = Math.max(columns.length, titles.length); _i17 < _len21; _i17++) {
              var title = titles[_i17];
              var column = columns[_i17];
              if (column) {
                lastId = Math.max(lastId, +column.getAttribute("id"));
                if (column.hasAttribute("dataDxfId")) {
                  lastDxfId = Math.max(lastDxfId, +column.getAttribute("dataDxfId"));
                }
              }
              if (!column) {
                column = myTable.xmldoc.createElement("tableColumn");
                lastId++;
                column.setAttribute("id", lastId);
                if (lastDxfId !== -1) {
                  column.setAttribute("dataDxfId", lastDxfId);
                }
                tcParent.appendChild(column);
              }
              if (title != null) {
                column.setAttribute("name", title);
              }
              if (!title) {
                columnsToDrop.push(column);
              }
            }
            columnsToDrop.forEach(drop);
          });
        }
      }
      var titleColor = get(tagValue, "styles.title.color");
      if (titleColor) {
        titleColor = titleColor.substr(1).toUpperCase();
        var styleEl = myChartXml.getElementsByTagName("c:title")[0];
        if (styleEl) {
          var clrs = styleEl.getElementsByTagName("a:srgbClr");
          for (var _i18 = 0, _len22 = clrs.length; _i18 < _len22; _i18++) {
            clrs[_i18].setAttribute("val", titleColor);
          }
        }
      }
      if (myTables.length > 0) {
        var globalRef = stringifyRange([topLeft, bottomRight]);
        myTables.forEach(function (myTable) {
          myTable.xml.setAttribute("ref", globalRef);
        });
      }
      if (subExcel) {
        Object.keys(sheets).forEach(function (fileName) {
          subExcel.file(fileName, xml2str(sheets[fileName]));
        });
        this.zip.file(subExcelPath, subExcel.generate({
          type: "arraybuffer"
        }));
      }
      result.errors = errors;
      return result;
    }
  }, {
    key: "on",
    value: function on(event) {
      var _this3 = this;
      if (event !== "syncing-zip") {
        return;
      }
      this.toSync.forEach(function (toSync) {
        if (!_this3.xmlDocuments[toSync.path]) {
          _this3.xmlDocuments[toSync.path] = str2xml(_this3.zip.file(toSync.path).asText());
        }
        var sheet = _this3.xmlDocuments[toSync.path];
        if (!sheet) {
          return;
        }
        syncXlsxContent(sheet, toSync.parsed, toSync.data, _this3.xmlDocuments["xl/sharedStrings.xml"]);
      });
    }
  }]);
  return ChartModule;
}();
module.exports = ChartModule;